<div id="not-found" class="bold">
  <span i18>{{ 'public.commons.noPageFound' | translate }}</span>
</div>
